import { Component, OnInit } from '@angular/core';
import { EnvService } from '../../../shared/services/env.service';
import { PasswordStrengthComponent } from '../../../password-strength/password-strength.component';
import { FormBuilder, AbstractControl, FormControl, ValidationErrors, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd';
import { NzModalService } from 'ng-zorro-antd';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { RestProvider } from '../../../shared/services/rest.provider';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.css']
})
export class SSOComponent implements OnInit {
  public href: string = "";
  public bannerLogo: any;
  public records : any[] = [];
  public patientPortalUrl: any;
  uniqueId: string;
  loginUrl: string;
  clientId: string;
  accountId: string;
  memberId: string;
  errorMessage: string;
  currentDate: any;
  today: any;
  isLoaded: boolean;

  constructor(private fb: FormBuilder,
              private spinnerService: Ng4LoadingSpinnerService,
              public restProvider: RestProvider,
              public router: Router,
              public route: ActivatedRoute,
              private env: EnvService,
              private modalService: NzModalService,
              private message: NzMessageService) {

                this.spinnerService.show();
                const parsedUrl = new URL(window.location.href);
                const baseUrl = parsedUrl.origin;
                this.setAPIUrl(baseUrl);
                this.currentDate = new Date();
                var res = this.router.url.split('/');
                this.clientId = res[2].substring(0,36);
                //now get params
                this.memberId = this.route.snapshot.queryParamMap.get('memberid');
                this.loadData();
                this.isLoaded = false;
  }

  ngOnInit() {}

  loadData(){
    if(this.memberId!='' && this.clientId!=''){
      var payload = {
        memberid: this.memberId
      };
      this.restProvider.loginSSOMember(this.clientId,payload).subscribe((recs : any[])=>{
        this.records = null;
        this.records = recs['body'];
        if(this.records['error']===null){
          let memberId = this.records['result'].memberId;
          let idToken = this.records['result'].idToken;
          let accessToken = this.records['result'].accessToken;
          let url = this.loginUrl+'/#/login?jwt='+idToken+'&jwt2='+accessToken;
          window.location.href = url;
        }else{
          this.spinnerService.hide();
          this.errorMessage = recs['error'];
        }
      });
    }
    else{
      this.spinnerService.hide();
      this.errorMessage = 'invalid link';
    }
  }

  setAPIUrl(baseUrl){
      switch(baseUrl) {
        case 'https://talk.dev.memd.me':
          this.env.CORE_API_URL = 'https://dev-integrations.memd.me';
          localStorage.setItem('partnerUrl','https://dev-partners.memd.me');
          this.loginUrl = 'https://patient.dev.memd.me';
          break;
        case 'https://talk.staging.memd.me':
          this.env.CORE_API_URL = 'https://staging-integrations.memd.me';
          localStorage.setItem('partnerUrl','https://staging-partners.memd.me');
          this.loginUrl = 'https://patient.staging.memd.me';
          break;
        case 'https://talk.memd.me':
          this.env.CORE_API_URL = 'https://integrations.memd.me';
          localStorage.setItem('partnerUrl','https://partners.memd.me');
          this.loginUrl = 'https://patient.memd.me';
          break;
        default:
          this.env.CORE_API_URL = 'https://dev-integrations.memd.me';
          localStorage.setItem('partnerUrl','https://dev-partners.memd.me');
          this.loginUrl = 'https://patient.dev.memd.me';
      }
  }

}
